/**
 * CREA/REALTOR.ca Compliance Components
 * Required on all pages displaying DDF listing content.
 */

const REALTOR_BADGE_URL = "https://www.realtor.ca/images/en-ca/powered_by_realtor.svg";

/**
 * Powered by REALTOR.ca badge — links to original listing on REALTOR.ca.
 * CREA requirement: minimum 90px wide, linked to listing.
 */
export function PoweredByRealtor({ moreInfoLink, className = "" }) {
  const badge = (
    <img
      src={REALTOR_BADGE_URL}
      alt="Powered by REALTOR.ca"
      className={`inline-block min-w-[90px] ${className}`}
      style={{ minWidth: '90px' }}
    />
  );

  if (moreInfoLink) {
    return (
      <a href={moreInfoLink} target="_blank" rel="noopener noreferrer" title="View on REALTOR.ca">
        {badge}
      </a>
    );
  }
  return badge;
}

/**
 * MLS® and REALTOR® trademark disclaimer.
 * CREA requirement: Must appear on every page displaying DDF content.
 */
export function CreaDisclaimer({ className = "" }) {
  return (
    <div className={`text-[10px] text-slate-400 leading-relaxed ${className}`} data-testid="crea-disclaimer">
      <p>
        The trademarks MLS®, Multiple Listing Service® and the associated logos are owned by The Canadian Real Estate Association (CREA) and identify the quality of services provided by real estate professionals who are members of CREA. The trademarks REALTOR®, REALTORS® and the REALTOR® logo are controlled by CREA and identify real estate professionals who are members of CREA.
      </p>
    </div>
  );
}

/**
 * Full CREA compliance footer block for listing pages.
 * Includes: Powered by badge + trademark disclaimer + brokerage attribution.
 */
export function CreaComplianceFooter({ moreInfoLink, agentName, officeName, className = "" }) {
  return (
    <div className={`border-t border-slate-200 pt-6 mt-8 space-y-4 ${className}`} data-testid="crea-compliance-footer">
      {/* Brokerage attribution */}
      {(agentName || officeName) && (
        <p className="text-xs text-slate-500">
          Listed by {agentName && <span className="font-medium text-slate-700">{agentName}</span>}
          {agentName && officeName && ', '}
          {officeName && <span className="text-slate-600">{officeName}</span>}
        </p>
      )}

      {/* Powered by REALTOR.ca badge */}
      <div className="flex items-center justify-center">
        <PoweredByRealtor moreInfoLink={moreInfoLink} className="h-8 opacity-70 hover:opacity-100 transition-opacity" />
      </div>

      {/* Trademark disclaimer */}
      <CreaDisclaimer />
    </div>
  );
}
